import React, { FC } from 'react';
import { iconSize } from '../../../../../../constants/icon.constants';
import Icon from '../../../../../@shared/icon';
import './styles.scss';
import useAnimationEnd from '../../../../../../hooks/useUnMountOnAnimationEnd';
import { TSelectedFilterOptions } from '../../../../types/dealerLocatorLanding.types';

export type TAccordionProps = {
  accordionTitle?: JSX.Element;
  accordionOptions?: Partial<{
    Code?: string;
    Title?: JSX.Element | string;
    TitleUrl?: string;
    codeList?: Array<string>;
  }>[];
  canShowAccordionContent: boolean;
  handleSwitchClick: () => void;
  handleCheckBoxClick: () => void;
  localSelectedFilter: TSelectedFilterOptions;
  setLocalSelectedFilter: React.Dispatch<React.SetStateAction<TSelectedFilterOptions>>;
};

const Accordion: FC<TAccordionProps> = ({
  accordionTitle: title = '',
  accordionOptions = [],
  localSelectedFilter = {},
  setLocalSelectedFilter,
  canShowAccordionContent = false,
  handleSwitchClick,
  handleCheckBoxClick,
}) => {
  const canShowDOM = useAnimationEnd(canShowAccordionContent, 290);

  const saveLocalSelectedFilter = (TitleUrl: string, codeList: Array<string>, isChecked) => {
    const localSelectedFilterCopy = localSelectedFilter;
    if (isChecked) {
      delete localSelectedFilterCopy[TitleUrl];
    } else {
      localSelectedFilterCopy[TitleUrl] = codeList;
    }
    setLocalSelectedFilter({ ...localSelectedFilterCopy });
  };

  if (!accordionOptions.length) return <></>;

  return (
    <div className="dealer-accordion-filter">
      <div
        className={`dealer-accordion-filter__switch${canShowAccordionContent ? ' dealer-accordion-filter__switch--open' : ''}`}
        onClick={handleSwitchClick}
      >
        {title}
        <Icon iconName={`arrow-chevron-${canShowAccordionContent ? 'up' : 'down'}`} size={iconSize['dsk']} />
      </div>
      {canShowDOM && (
        <div className={`dealer-accordion-filter__panel dealer-accordion-filter__panel${canShowAccordionContent ? '--open' : '--closed'}`}>
          {accordionOptions?.map(({ TitleUrl = '', Title = '', codeList }) => {
            const isChecked = localSelectedFilter[TitleUrl];

            return (
              <label
                htmlFor={TitleUrl}
                className="dealer-accordion-filter__panel-item"
                onClick={() => {
                  codeList && saveLocalSelectedFilter(TitleUrl, codeList, isChecked);
                  handleCheckBoxClick();
                }}
              >
                <Icon iconName={isChecked ? 'action-checkbox-checked' : 'action-checkbox-default'} size={iconSize['dsk']} />
                <span>{Title}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Accordion;
